import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  isWithinInterval,
  setDefaultOptions,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
  sub
} from 'date-fns'

setDefaultOptions({ weekStartsOn: 1, firstWeekContainsDate: 4 })

export const QUICK_FILTERS = {
  thisWeek: 'This Week',
  lastWeek: 'Last Week',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  thisYear: 'This Year',
  lastYear: 'Last Year'
}

export const formatDate = (date, offset) => {
  if (!date) return null
  if (offset === 'start') {
    return startOfDay(date).toISOString()
  } else if (offset === 'end') {
    return endOfDay(date).toISOString()
  } else {
    return date.toISOString()
  }
}

export const getFilter = value => {
  let startDate
  let endDate

  switch (value) {
    case QUICK_FILTERS.thisWeek: {
      startDate = startOfWeek(new Date())
      endDate = new Date()
      break
    }

    case QUICK_FILTERS.lastWeek: {
      const lastWeek = sub(new Date(), { weeks: 1 })

      startDate = startOfWeek(lastWeek)
      endDate = endOfWeek(lastWeek)

      break
    }
    case QUICK_FILTERS.thisMonth: {
      startDate = startOfMonth(new Date())
      endDate = new Date()
      break
    }

    case QUICK_FILTERS.lastMonth: {
      const lastMonth = sub(new Date(), { months: 1 })

      startDate = startOfMonth(lastMonth)
      endDate = endOfMonth(lastMonth)
      break
    }

    case QUICK_FILTERS.thisYear:
      startDate = startOfYear(new Date())
      endDate = new Date()

      break

    case QUICK_FILTERS.lastYear: {
      const lastYear = sub(new Date(), { years: 1 })

      startDate = startOfYear(lastYear)
      endDate = endOfYear(lastYear)

      break
    }

    default:
      break
  }

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  }
}

export const isBetweenSelection = (date, startDate, endDate) => {
  return isWithinInterval(date, {
    start: startDate,
    end: endDate
  })
}
